import React from 'react';
import Add from './Add';

const Edit = ({ data, handleClick }) => {
  return <Add data={data} handleClick={handleClick} />;
};

export default Edit;
